
<app-admin-side-bar></app-admin-side-bar>

  <!-- Navbar -->
  <nav class="main-header navbar navbar-expand navbar-dark">
    <!-- Left navbar links -->
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link" appRemoveOverlayDirective data-widget="pushmenu" href="#" role="button"><i class="fas fa-bars"></i></a>
      </li>
      <li class="nav-item d-none d-sm-inline-block">
        <a class="nav-link">Home</a>
      </li>
      <li class="nav-item d-none d-sm-inline-block">
        <a class="nav-link">Transaction Report</a>
      </li>
    </ul>
  
    <!-- Right navbar links -->
    <ul class="navbar-nav ml-auto" *ngIf="Role=='1'">
      <li class="nav-item dropdown">
        <a><app-admin-test-mode></app-admin-test-mode> </a>
      </li>
    </ul>
  </nav>
  <!-- /.navbar -->
  
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Transaction Report</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item"><a>Home</a></li>
              <li class="breadcrumb-item active">Transcation Report</li>
            </ol>
          </div>
        </div>
      </div><!-- /.container-fluid -->
    </section>
  
    <div class="container-fluid" style="padding: 15px;">
      <div class="row">
        <section class="col-md-12">
          <button class="btnDef" (click)="exportData()">Export CSV</button> &nbsp;&nbsp;
          <button class="btnDef" (click)="exportDataPDF()">Export PDF</button>
  
        </section>
      </div>
      <br>
      <div class="row">
        <div class="col-md-2 col-sm-3">
          <select class="form-control" (change)="onSelectChange($event.target)">
            <option>Select</option>
            <option value="1">Today</option>
            <option value="2">Yesterday</option>
            <option value="3">This week</option>
            <option value="4">Last Week</option>
            <option value="5">This Month</option>
            <option value="6">Last Month</option>
            <option value="7">Custom</option>
          </select>
        </div>

        <div class="col-md-2 col-sm-3">
          <select class="form-control" [(ngModel)]="productId" (change)="changeActiveProduct()">
            <option selected value="0">Select Product</option>
            <option *ngFor="let item of activeProducts" value="{{item.id}}">
                {{item.productName}}
            </option>
        </select>
        </div>
        <div class="col-md-3 col-sm-5" *ngIf="boolCustom">
          <mat-form-field style="height: 50px;" class="example-full-width mb-3">
            <mat-date-range-input style="margin-top: -12px;" [rangePicker]="picker">
              <input style="position: absolute; top:0px" matStartDate placeholder="Start Date & Time" [(ngModel)]="startDate">
              <input matEndDate placeholder="End Date & Time" [(ngModel)]="endDate">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        </div>
        &nbsp;&nbsp;
        <div *ngIf="Role==1"   class="col-md-3 pull-right">
          <mat-form-field  class="date-range-picker" style="height: 50px; " appearance="fill">
            <mat-select (selectionChange)="filterRetailers($event)" style="position: absolute; top:0px" #retailerSelect [placeholder]="'Select Retailer'">
              <!-- <input class="filterTextBox" matInput placeholder="'Search retailer'" [(ngModel)]="filterRetailer"
                (change)="filterRetailers($event.target)" autocomplete="off"> -->
                <mat-option [value]="0">Select All</mat-option>
              <mat-option *ngFor="let retailer of Retailers" [value]="retailer.id">
                {{ retailer.fullName }}
              </mat-option>
            </mat-select>
            <button style="width: 10% !important; border: 0px;" mat-button matSuffix (click)="retailerSelect.open()">
            </button>
          </mat-form-field>
        </div>
        <section class="col-md-2 col-sm-3" style="float: right;">
          <div class="form-group d-flex align-items-center mx-2">
              <label for="filter" class="mr-2 mb-0">Filter:</label>
              <input type="text" class="form-control" id="filter" #keyword placeholder="Search">
          </div>
      </section>
        <div class="col-1 mt-1 mx-2">
          <button class="btnDef" (click)="Filter(keyword.value)">Search</button>
        </div>
        
        <hr class="mt-3">
      
<!-- card -->
<div *ngIf="loader1==true">
  <app-loader style="text-align: center;"></app-loader>
</div>
       <div class="container mt-5">
        <div class="row">
            <div class="col-md-4 col-xl-3">
                <div class="card bg-c-blue order-card">
                    <div class="card-block">
                        <h2 class="m-b-20">Retail Price</h2>
                        <h2 class="m-b-0 fas fa-dollar-sign" style="text-align: center;" > {{retailPrice}}<span  ></span></h2>
                    </div>
                </div>
            </div>
            <div class="col-md-4 col-xl-3">
                <div class="card bg-c-green order-card">
                    <div class="card-block">
                        <h2 class="m-b-20">Discount</h2>
                        <h2 class="m-b-0 fas fa-dollar-sign" style="text-align: center;" > {{discount}}<span  ></span></h2>
                    </div>
                </div>
            </div>
            <div class="col-md-4 col-xl-3">
                <div class="card bg-c-yellow order-card">
                    <div class="card-block">
                        <h2 class="m-b-20">Retail Cost</h2>
                        <h2 class="m-b-0 fas fa-dollar-sign" style="text-align: center;" > {{retailCost}}<span  ></span></h2>

                    </div>
                </div>
            </div>
            <div class="col-md-4 col-xl-3" *ngIf="Role==1">
                <div class="card bg-c-pink order-card">
                    <div class="card-block">
                        <h2 class="m-b-20">Prid Profit</h2>
                        <h2 class="m-b-0 fas fa-dollar-sign" style="text-align: center;" > {{pridProfit}}<span  ></span></h2>
                    </div>
                </div>
            </div>
      </div>
    </div>
        <section class="col-md-12 mt-2">
          <div class="card">
            <!-- /.card-header -->
            <div class="card-body">
              <div class="row">
                <div class="col-5"></div>
                <div class="col-2">
                  <div *ngIf="loader==true">
                    <app-loader style="text-align: center;"></app-loader>
                  </div>
                </div>
                <div class="col-5"></div>
              </div>
              <table *ngIf="!loader" id="example2" class="table table-bordered table-hover table-responsive">

                  <tr>
                    <th>Date/Time</th>
                    <th>Product Info</th>
                    <th *ngIf="Role==1">Retailer</th>
                    <!-- <th>Retail Price</th> -->
                    <th>Quantity</th>
                    <th>Total Retail Price</th>
                    <th>Discount(%)</th>
                    <th>Discount Amount</th> 
                    <!-- <th>Retail Cost</th> -->
                    <th>Total Retail Cost</th>
                    <th>Status</th>
                    <th>Order Number</th>
                    <th>Primary Number</th>
                    <th>Recharged Number</th>
                  </tr>
                  <tr *ngFor="let item of Orderitems; let i = index" [ngClass]="getRowClass(i)">
                    <td>{{ item.transactionDate | date: 'short' }}</td>
                    <td>{{ item.operator }}</td>
                    <td *ngIf="Role==1">{{ item.retailerName }}</td>
                    <!-- <td>{{ item.retailPrice }}</td> -->
                    <td>{{ item.quantity }}</td>
                    <td>{{ item.totalRetailPrice }}</td>
                    <td>{{ item.discountPercentage }}</td>
                    <td>{{ item.totalDiscountAmount }}</td>
                    <!-- <td>{{ item.retailCost }}</td> -->
                    <td>{{ item.totalRetailCost }}</td>
                    <!-- <td [ngClass]="item.status ? 'status-success' : 'status-warning'">
                      {{ item.status ? 'Success' : 'Warning' }}
                    </td> -->
                    <td>{{item.itemStatus}}</td>
                    <td>
                      {{ item.orderNumber }}
                      <span style="background:transparent; cursor: pointer;" class="mx-2" (click)="PrintRecipt(item.orderNumber)">
                        <i class="fa fa-print"></i>
                    </span>
                    </td>
                    <td>{{ item.primaryNumber }}</td>
                    <td>{{ item.recharegedNumber }}</td>
                  </tr>
              </table>
              
            </div>
            <div class="d-flex justify-content-center my-3" *ngIf="totalItems > 0">
              <app-pager [totalCount]="totalItems" [pageSize]="100" (pageChanged)="onPageChanged($event)"></app-pager>
            </div>
  
            <!-- /.card-body -->
          </div>
        </section>
      </div>
    </div>
  </div>
    